export default __webpack_public_path__ + "static/media/(63).c937a90d.jpg";